import { Phone, Mail, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_source-scout-4/artifacts/hca8zcbd_WhatsApp%20Image%202026-02-28%20at%2022.18.51.jpeg";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home', href: '#hero' },
    { label: 'Products', href: '#products' },
    { label: 'Services', href: '#services' },
    { label: 'Contact', href: '#contact' },
    { label: 'Admin Login', href: '/admin/login' },
  ];

  const products = [
    'Laptops',
    'Desktops',
    'CCTV Cameras',
    'Biometrics',
    'Accessories',
  ];

  const services = [
    'Computer Repair',
    'AMC Plans',
    'Networking',
    'Software Installation',
    'IT Consultation',
  ];

  return (
    <footer data-testid="footer" className="footer-bg pt-20 pb-8">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Column 1 - About */}
          <div>
            <img
              src={LOGO_URL}
              alt="Tejas Info Solutions"
              className="h-14 w-auto object-contain mb-6"
              data-testid="footer-logo"
            />
            <p className="text-slate-400 mb-6 leading-relaxed">
              Tejas Info Solutions is your trusted IT partner since 2012, providing quality hardware and services in Bengaluru.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-slate-400">
                <Phone className="h-4 w-4 text-orange-500" />
                <span>091363 51639</span>
              </div>
              <div className="flex items-center gap-3 text-slate-400">
                <Mail className="h-4 w-4 text-orange-500" />
                <span>info@tejasinfosolutions.com</span>
              </div>
              <div className="flex items-center gap-3 text-slate-400">
                <MapPin className="h-4 w-4 text-orange-500" />
                <span>Bengaluru, Karnataka</span>
              </div>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                    className="text-slate-400 hover:text-orange-500 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Products */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6">Products</h4>
            <ul className="space-y-3">
              {products.map((product) => (
                <li key={product}>
                  <span className="text-slate-400">{product}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 - Services */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6">Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-slate-400">{service}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Copyright */}
            <p className="text-slate-500 text-sm">
              © {currentYear} Tejas Info Solutions. All rights reserved.
            </p>

            {/* Authorized brands */}
            <div className="flex items-center gap-4 text-slate-500 text-sm">
              <span>Authorized Dealer:</span>
              <span className="text-slate-400">Lenovo</span>
              <span>|</span>
              <span className="text-slate-400">HP</span>
              <span>|</span>
              <span className="text-slate-400">CP Plus</span>
              <span>|</span>
              <span className="text-slate-400">Hikvision</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
